<template>
    <div>
      <!-- Contenedor principal para colocar ambas secciones en una fila -->
      <Loader :loading="isLoading" />
      <loader-component v-if="isLoading" :loading="isLoading" />
      
      <div class="flex flex-col lg:flex-row gap-4">
        <!-- Sección perfil contraseña -->
        <div class="w-full lg:w-1/3 bg-white rounded-lg shadow">
          <div class="p-4 rounded-lg">
            <div class="card-header text-left py-2">
              <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal" >
                Editar Perfil de {{ (name || '') + ' ' + (last_name || '') }}
              </div>
            </div>
            
            <div class="card-header text-left py-2">
              <h4 class="text-style-base">
                Header
              </h4>
            </div>
            <!-- Foto de portada -->
            <div class="w-full h-32 sm:h-48 bg-cover bg-center rounded-lg relative" 
               :style="{ backgroundImage: `url(${profileImageSrc || defaultImage})` }">
              <!-- Botón para quitar la imagen -->
              <button 
                v-if="profileImageSrc"
                @click.stop="removeProfile"
                class="absolute top-2 left-2 bg-white text-red-500 rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-red-500 hover:text-white transition duration-300 z-20"
                title="Quitar imagen"
              >
                &times; <!-- Símbolo de X -->
              </button>
              <div class="absolute top-2 right-2 z-10 flex items-center justify-center">
                <!-- Contenedor para el círculo y el lápiz -->
                <div class="relative">
                  <!-- Círculo rosa -->
                  <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none" class="absolute top-0 right-0 z-10">
                    <circle cx="16.5" cy="16.5" r="16.5" fill="#FF4265"/>
                  </svg>

                  <!-- Lápiz centrado dentro del círculo, ajustado para estar perfectamente centrado -->
                  <label for="profile_cover" class="cursor-pointer absolute top-1 left-1/2 transform -translate-x-6 -translate-y-1/12 z-20">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                      <g clip-path="url(#clip0_2110_2581)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4649 0.157368C14.3594 0.0519157 14.2164 -0.00732422 14.0672 -0.00732422C13.9181 -0.00732422 13.775 0.0519157 13.6695 0.157368L11.8166 2.01024L15.987 6.18062L17.8399 4.32887C17.8923 4.27662 17.9338 4.21454 17.9622 4.14621C17.9906 4.07787 18.0051 4.00461 18.0051 3.93062C18.0051 3.85663 17.9906 3.78337 17.9622 3.71503C17.9338 3.64669 17.8923 3.58462 17.8399 3.53237L14.4649 0.157368ZM15.1916 6.97599L11.0213 2.80562L3.70877 10.1181H3.94165C4.09083 10.1181 4.2339 10.1774 4.33939 10.2829C4.44488 10.3884 4.50415 10.5314 4.50415 10.6806V11.2431H5.06665C5.21583 11.2431 5.3589 11.3024 5.46439 11.4079C5.56988 11.5134 5.62915 11.6564 5.62915 11.8056V12.3681H6.19165C6.34083 12.3681 6.4839 12.4274 6.58939 12.5329C6.69488 12.6384 6.75415 12.7814 6.75415 12.9306V13.4931H7.31665C7.46583 13.4931 7.6089 13.5524 7.71439 13.6579C7.81988 13.7634 7.87914 13.9064 7.87914 14.0556V14.2885L15.1916 6.97599ZM6.79014 15.3775C6.76647 15.3145 6.75428 15.2479 6.75415 15.1806V14.6181H6.19165C6.04246 14.6181 5.89939 14.5589 5.7939 14.4534C5.68841 14.3479 5.62915 14.2048 5.62915 14.0556V13.4931H5.06665C4.91746 13.4931 4.77439 13.4339 4.6689 13.3284C4.56341 13.2229 4.50415 13.0798 4.50415 12.9306V12.3681H3.94165C3.79246 12.3681 3.64939 12.3089 3.5439 12.2034C3.43841 12.0979 3.37915 11.9548 3.37915 11.8056V11.2431H2.81665C2.74939 11.243 2.68271 11.2308 2.61977 11.2071L2.4184 11.4074C2.36479 11.4614 2.32269 11.5256 2.29465 11.5964L0.0446458 17.2214C0.00372885 17.3236 -0.00628759 17.4356 0.0158383 17.5434C0.0379642 17.6513 0.0912594 17.7503 0.169117 17.8281C0.246974 17.906 0.345969 17.9593 0.45383 17.9814C0.561691 18.0036 0.673674 17.9935 0.775896 17.9526L6.40089 15.7026C6.47162 15.6746 6.53591 15.6325 6.5899 15.5789L6.79014 15.3786V15.3775Z" fill="white"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_2110_2581">
                          <rect width="18" height="18" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </label>
                </div>

                <!-- Input file oculto para cambiar la imagen -->
                <input type="file" id="profile_cover" style="display: none;" @change="updateCoverImage" />
              </div>
            </div>
             <!-- Foto de perfil -->
             <div class="user-image mt-4 relative">
                <input type="file" id="profile_avatar" style="display: none" @change="updateProfileImage" />
                <div class="avatar relative">
                  <img 
                    :src="imageSrc || defaultProfileImage" 
                    alt="Avatar" 
                    id="image_profile" 
                    class="rounded-full w-26 h-26 mx-auto mb-2" 
                  />
                  <!-- Botón para quitar la imagen -->
                  <button 
                    v-if="imageSrc"
                    @click.stop="removeImage"
                    class="absolute top-2 right-2 bg-white text-red-500 rounded-full w-6 h-6 flex items-center justify-center shadow-md hover:bg-red-500 hover:text-white transition duration-300 z-20"
                    title="Quitar imagen"
                  >
                    &times; <!-- Símbolo de X -->
                  </button>
                    <!-- Círculo rosa sobre la imagen de perfil -->
                    <div class="absolute flex items-center justify-center w-full h-full top-0 left-0 z-10">
                      <!-- Círculo rosa -->
                      <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33" fill="none" class="absolute bottom-0 left-1/2 transform -translate-x-1/2 z-20">
                        <circle cx="16.5" cy="16.5" r="16.5" fill="#FF4265"/>
                      </svg>

                      <!-- Lápiz centrado dentro del círculo -->
                      <label for="profile_avatar" class="cursor-pointer absolute bottom-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-20">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <g clip-path="url(#clip0_2110_2581)">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4649 0.157368C14.3594 0.0519157 14.2164 -0.00732422 14.0672 -0.00732422C13.9181 -0.00732422 13.775 0.0519157 13.6695 0.157368L11.8166 2.01024L15.987 6.18062L17.8399 4.32887C17.8923 4.27662 17.9338 4.21454 17.9622 4.14621C17.9906 4.07787 18.0051 4.00461 18.0051 3.93062C18.0051 3.85663 17.9906 3.78337 17.9622 3.71503C17.9338 3.64669 17.8923 3.58462 17.8399 3.53237L14.4649 0.157368ZM15.1916 6.97599L11.0213 2.80562L3.70877 10.1181H3.94165C4.09083 10.1181 4.2339 10.1774 4.33939 10.2829C4.44488 10.3884 4.50415 10.5314 4.50415 10.6806V11.2431H5.06665C5.21583 11.2431 5.3589 11.3024 5.46439 11.4079C5.56988 11.5134 5.62915 11.6564 5.62915 11.8056V12.3681H6.19165C6.34083 12.3681 6.4839 12.4274 6.58939 12.5329C6.69488 12.6384 6.75415 12.7814 6.75415 12.9306V13.4931H7.31665C7.46583 13.4931 7.6089 13.5524 7.71439 13.6579C7.81988 13.7634 7.87914 13.9064 7.87914 14.0556V14.2885L15.1916 6.97599ZM6.79014 15.3775C6.76647 15.3145 6.75428 15.2479 6.75415 15.1806V14.6181H6.19165C6.04246 14.6181 5.89939 14.5589 5.7939 14.4534C5.68841 14.3479 5.62915 14.2048 5.62915 14.0556V13.4931H5.06665C4.91746 13.4931 4.77439 13.4339 4.6689 13.3284C4.56341 13.2229 4.50415 13.0798 4.50415 12.9306V12.3681H3.94165C3.79246 12.3681 3.64939 12.3089 3.5439 12.2034C3.43841 12.0979 3.37915 11.9548 3.37915 11.8056V11.2431H2.81665C2.74939 11.243 2.68271 11.2308 2.61977 11.2071L2.4184 11.4074C2.36479 11.4614 2.32269 11.5256 2.29465 11.5964L0.0446458 17.2214C0.00372885 17.3236 -0.00628759 17.4356 0.0158383 17.5434C0.0379642 17.6513 0.0912594 17.7503 0.169117 17.8281C0.246974 17.906 0.345969 17.9593 0.45383 17.9814C0.561691 18.0036 0.673674 17.9935 0.775896 17.9526L6.40089 15.7026C6.47162 15.6746 6.53591 15.6325 6.5899 15.5789L6.79014 15.3786V15.3775Z" fill="white"/>
                          </g>
                          <defs>
                            <clipPath id="clip0_2110_2581">
                              <rect width="18" height="18" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                      </label>
                    </div>
                </div>
              </div>
              
            <div class="card-body space-y-4">
              <!-- Campo de email -->
              <div class=" mb-1">
                <label class="text-style-sm">Email</label>
                <fwb-input v-model="email" required placeholder="Ingresa tu email" class="w-full bg-white text-box" />
              </div>

              <!-- Campo para nueva contraseña -->
              <div class=" mb-1">
                <label class="text-style-sm">Nueva Contraseña</label>
                <fwb-input v-model="password" type="password" required placeholder="Ingrese su nueva contraseña" class="w-full bg-white text-box" />
              </div>

              <!-- Campo para confirmar nueva contraseña -->
              <div class=" mb-1">
                <label class="text-style-sm">Confirmar Contraseña</label>
                <fwb-input v-model="passwordConfirmation" type="password" required placeholder="Confirme su nueva contraseña" class="w-full bg-white text-box" />
              </div>

              <!-- Botón para enviar nueva contraseña -->
              <div class="form-footer text-end">
                <button @click="updateAccount" class="custom-create-btn">
                  <span class="custom-create-btn-text">Guardar</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Información General -->
        <form @submit.prevent="saveData" class="w-full lg:w-2/3 bg-white rounded-lg shadow">
          <div class="p-4">
            <div class="card-header text-left py-2">
              <div class="text-neutral-500 text-xl font-medium font-['Poppins'] leading-normal">
                Información Personal
              </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="col-span-full">
                <label for="roles" class="text-style-sm">Selecciona los roles:</label>
                <div class="flex flex-wrap gap-2">
                  <div v-for="rol in roles" :key="rol.id" class="role-item d-flex align-items-center">
                    <input
                      class="form-check-input"
                      :id="'rol_' + rol.id"
                      type="checkbox"
                      :value="rol.id"
                      v-model="selectedRoles"
                      @change="checkAllSelected"
                    />
                    <label class="text-box ms-2" :for="'rol_' + rol.id">{{ rol.name }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <!-- Primera columna -->
              <div>
                <label class="text-style-sm mt-4 block">Ingresa tu nombre</label>
                <input
                  v-model="name"
                  type="text"
                  placeholder="Ingresa tu nombre"
                  class="w-full px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                  required
                />
              </div>

              <!-- Segunda columna -->
              <div>
                <label class="text-style-sm mt-4 block">Fecha de nacimiento</label>
                <input
                  v-model="birthday"
                  type="date"
                  class="w-full px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                />
              </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="text-style-sm mt-4 block">Apellido paterno</label>
                <input
                  v-model="last_name"
                  type="text"
                  placeholder="Ingresa tu apellido paterno"
                  class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                  required
                />
              </div>
              <div>
                <label class="text-style-sm mt-4 block">Apellido materno</label>
                <input
                  v-model="last_second_name"
                  type="text"
                  placeholder="Ingresa tu apellido materno"
                  class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                  required
                />
              </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="text-style-sm mt-4 block">Email</label>
                <input
                  v-model="email"
                  type="email"
                  required
                  placeholder="Ingresa tu email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                />
              </div>
              <div>
                <label class="text-style-sm mt-4 block">Teléfono</label>
                <input
                  type="tel"
                  v-model="phone"
                  class="self-stretch px-4 py-[9px] bg-white rounded-md border border-[#dee2e6] text-neutral-500 text-sm font-light font-['Poppins'] leading-normal"
                  pattern="[\d\s\+\-\(\)]{10,}"
                  title="Ingrese un número de teléfono válido (mínimo 10 dígitos)"
                  required
                  placeholder="Ingresa tu teléfono"
                />
              </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="text-style-sm mt-4 block">Compañía</label>
                  <select class="w-full rounded-md border border-gray-300 p-2 bg-white text-gray-900 text-box" v-model="user.company_id">
                    <option value="0">Selecciona una compañía</option>
                    <option v-for="company in companies" :key="company.id" :value="company.id">
                      {{ company.name }}
                    </option>
                  </select>
              </div>
              <div>
                <label class="text-style-sm mt-4 block">Cargo</label>
                <select class="w-full rounded-md border border-gray-300 p-2 bg-white text-gray-900 text-box" v-model="user.position_id">
                  <option value="0">Selecciona un cargo</option>
                  <option v-for="cargo in cargos" :key="cargo.id" :value="cargo.id">
                    {{ cargo.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="text-style-sm mt-4 block">Plan</label>
                <select class="w-full rounded-md border border-gray-300 p-2 bg-white text-gray-900 text-box" v-model="user.plan_id">
                  <option value="0">Selecciona un plan</option>
                  <option v-for="plan in plans" :key="plan.id" :value="plan.id">
                    {{ plan.name }}
                  </option>
                </select>
              </div>
              <div>
                <label class="text-style-sm mt-4 block">Tipo de Cuenta</label>
                <select class="w-full rounded-md border border-gray-300 p-2 bg-white text-gray-900 text-box" v-model="user.account_id">
                  <option value="0">Selecciona una cuenta</option>
                  <option v-for="account in accounts" :key="account.id" :value="account.id">
                    {{ account.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="p-2 flex flex-col">
              <div class="flex flex-1 flex-col p-2 text-gray-900">
                <label class="text-box mb-1">
                  <input
                    type="checkbox"
                    id="block_user"
                    v-model="blockUser"  
                    class="form-check-input"
                  />
                  Bloquear
                </label>
              </div>
            </div>
            <div class="col-span-full flex justify-end mt-4">
              <div class="flex justify-end space-x-4">
                <!-- Botón de Cancelar -->
                <button type="button" @click="$router.push('/users')">
                  <span class="custom-secondary-btn">Cancelar</span>
                </button>

                <button type="submit" class="bg-tuin-100 hover:bg-tuin-100 text-white font-bold py-2 px-4 rounded">
                  <span class="custom-create-btn-text">Actualizar Perfil</span>
                </button>
              </div>
            </div>
          </div>
          <div v-if="successMessage" class="user-alert">
            <div class="user-alert-content">
              <div class="user-alert-text">
                {{ successMessage }}
              </div>
            </div>
            <div class="w-4 h-4 relative"></div>
          </div>
          <head>
            <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
          </head>
        </form>
      </div>
  </div>
</template>

<script setup>
import { FwbInput} from "flowbite-vue";
import { ref, computed, onMounted } from "vue";
import axios from "axios";
import { useStore } from 'vuex';
import { useRoute } from "vue-router";
import 'vue-toastification/dist/index.css';
import Loader from '@/components/loaderComponent.vue';
import defaultProfileImage from '@/assets/imgs/1.png';
import defaultImage from '@/assets/imgs/2.png';
// Obtener la tienda de Vuex
const store = useStore();
const isLoading = ref(true); // Inicializamos isLoading
import { useRouter } from "vue-router";
let session = computed(() => store.getters.getUserSession);
const route = useRoute();
let userId = computed(() => route.params.id);
const emailError = ref('');
const phoneError = ref('');
const nameError = ref('');
const last_nameError = ref('');
const last_second_nameError = ref('');
const account_idError = ref('');
let selectedRoles = ref([]);
let router = useRouter();
// Variables reactivas
let name = ref();
let birthday = ref();
let email = ref();
let aboute_me = ref();
let phone = ref();
let  imageSrc = ref(null);
let profileImageSrc = ref(null);  // Variable para almacenar la URL de la imagen grande
let  blockUser = ref(false);
// Computed que devuelve la URL de la imagen a mostrar
let last_name = ref();
let last_second_name = ref();
let account_id = ref();
let step = ref(1);
let profile = ref();
let companies = ref([]); // Declaración de companies
let user = ref({ company_id: null, account_id: null });
let roles = ref([]); // Declaración de roles
let cargos = ref([]); // Declaración de cargos
let plans = ref([]); // Declaración de planes
let accounts = ref([]); // Declaración de cuentas
let password = ref('');
let passwordConfirmation = ref('');

const successMessage = ref('');
const isValidEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

// Phone validation function 
const isValidPhone = (phone) => {
  const phoneRegex = /^(\+?52\s?)?(\(\d{3}\)|\d{3})[\s.-]?\d{3}[\s.-]?\d{4}$/;
  return phoneRegex.test(phone);
};


console.log(imageSrc)

const removeImage = () => {
  imageSrc.value = '';
};
const removeProfile = () => {
  profileImageSrc.value = '';
};
// Obtener perfil
async function getProfile() {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };

    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${userId.value}`, options
    );

    if (response.status === 401) {
      store.dispatch('clearUserSession');
    }

    if (response.status === 200) {
      profile.value = response.data.resp.info;
      name.value = response.data.resp.info.name;
      last_name.value = response.data.resp.info.last_name;
      last_second_name.value = response.data.resp.info.last_second_name;
      email.value = response.data.resp.info.email;
      phone.value = response.data.resp.info.phone;
      aboute_me.value = response.data.resp.info.about_me;
      birthday.value = response.data.resp.info.birthday;
      user.value.company_id = response.data.resp.info.company_id; // Asigna el company_id
      user.value.plan_id = response.data.resp.info.plan_id; // Asigna el plan_id
      user.value.position_id = response.data.resp.info.position_id; // Asigna el position_id
      user.value.account_id = response.data.resp.info.account_id; // Asigna el position_id
      blockUser.value = response.data.resp.info.status === 'block';
      const profileAvatar = response.data.resp.info.profile_avatar;
      const profileImage = response.data.resp.info.profile_img;
      
      // Verifica si profileImage no es null antes de asignar la URL completa
      if (profileImage) {
        profileImageSrc.value = `${profileImage}`;
      } else {
        profileImageSrc.value = null; // O un valor por defecto
      }
      console.log(profileImage);

      // Asigna la imagen de avatar
      if (profileAvatar) {
        imageSrc.value = `${profileAvatar}`;
      } else {
        imageSrc.value = null; // O un valor por defecto
      }
      console.log(imageSrc.value);

      // Extrae los IDs de los roles asociados y asígnalos a selectedRoles
      selectedRoles.value = response.data.resp.info.roles.map(role => role.id);
    }
    isLoading.value = false; 
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}
async function updateProfileImage(event) {
    const file = event.target.files[0];
    if (file) {
      // Similar al de portada, puedes cargar la imagen en tu servidor o mostrarla localmente
      const reader = new FileReader();
      reader.onload = () => {
        imageSrc.value = reader.result;   // Actualiza la imagen en la vista
        console.log(imageSrc)
      };
      reader.readAsDataURL(file);  // Convierte la imagen a base64
    }
  }
  async function updateCoverImage(event) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        profileImageSrc.value = e.target.result;  // Actualiza la imagen de portada
      };
      reader.readAsDataURL(file);
    }
  }
// Obtener compañías
async function fetchCompanies() {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/companies`, options
    );

    if (response.status === 401) {
      store.dispatch('clearUserSession');
    }

    if (response.status === 200 && response.data?.resp?.companies) {
      companies.value = response.data.resp.companies; // Cambia esto
    } else {
      console.error("Error en la respuesta de la API: estructura inesperada");
    }
  } catch (error) {
    console.error("Error al obtener las compañías:", error);
  }
}

// Función para obtener roles
async function fetchRoles() { 
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };
    const response = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/roles`, options);
    
    // Verifica si la respuesta es un error de autorización
    if (response.status === 401) {
      store.dispatch('clearUserSession');
    }

    if (response.status === 200) {
      roles.value = response.data; // Asigna los roles correctamente
    }
  } catch (error) {
    console.error("Error al obtener los roles:", error);
  }
}

//obtener los cargos
async function fetchCargos() {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/cargos`, options
    );

    if (response.status === 401) {
      store.dispatch('clearUserSession');
    }

    // Accede a los cargos en response.data.cargos
    if (response.status === 200 && response.data?.cargos) {
      cargos.value = response.data.cargos; 
    } else {
      console.error("Error en la respuesta de la API: estructura inesperada");
    }
  } catch (error) {
    console.error("Error al obtener los cargos:", error);
  }
}

//obtener los cargos
async function fetchPlanes() {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/planes`, options
    );

    if (response.status === 401) {
      store.dispatch('clearUserSession');
    }

    // Accede a los cargos en response.data.cargos
    if (response.status === 200 && response.data?.plans) {
      plans.value = response.data.plans; 
    } else {
      console.error("Error en la respuesta de la API: estructura inesperada");
    }
  } catch (error) {
    console.error("Error al obtener los planes:", error);
  }
}

//obtener los cargos
async function fetchAccounts() {
  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };
    const response = await axios.get(
      `${process.env.VUE_APP_API_BASE_URL}/account`, options
    );

    if (response.status === 401) {
      store.dispatch('clearUserSession');
    }

    // Accede a los cargos en response.data.cargos
    if (response.status === 200 && response.data?.accounts) {
      accounts.value = response.data.accounts; 
    } else {
      console.error("Error en la respuesta de la API: estructura inesperada");
    }
  } catch (error) {
    console.error("Error al obtener los planes:", error);
  }
}

// Llama a la función para obtener los roles al montar el componente
onMounted(async () => {
  await Promise.all([
    fetchCompanies(),
    fetchRoles(),
    fetchCargos(),
    fetchPlanes(),
    fetchAccounts(),
    getProfile()  // Asegúrate de obtener el perfil después de las compañías
  ]);
});


// Función para manejar el cambio en los checkboxes
function checkAllSelected() {
  // Aquí puedes implementar la lógica si es necesario
  console.log(selectedRoles.value); // Muestra los roles seleccionados
}

// Función para guardar datos
async function saveData(){
  emailError.value = '';
  phoneError.value = '';
  nameError.value = '';
  last_nameError.value = '';
  last_second_nameError.value = '';
  account_idError.value = '';

  // Validate email
  if (!email.value) {
    emailError.value = 'El correo electrónico es obligatorio';
  } else if (!isValidEmail(email.value)) {
    emailError.value = 'Por favor, ingrese un correo electrónico válido';
  }
  if (!name.value) {
    nameError.value = 'El nombre es obligatorio';
  }
  if (!last_name.value) {
    last_nameError.value = 'El apellido paterno es obligatorio';
  }
  if (!last_second_name.value) {
    last_second_nameError.value = 'El apellido materno es obligatorio';
  }
  if (!account_id.value) {
    account_idError.value = 'El tipo de cuenta es obligatorio';
  }
  // Validate phone
  if (!phone.value) {
    phoneError.value = 'El número de teléfono es obligatorio';
  } else if (!isValidPhone(phone.value)) {
    phoneError.value = 'Por favor, ingrese un número de teléfono válido';
  }

  // If there are validation errors, stop the save process
  if (emailError.value || phoneError.value) {
    return;
  }

  if(session.value.step < 3){
    step.value              = 1; 
  }else{
    step.value              = session.value.step; 
  }

  let params = {
    'name'              : name.value, 
    'birthday'          : birthday.value,
    'email'             : email.value,
    'about_me'         : aboute_me.value,
    'phone'             : phone.value,
    'last_name'         : last_name.value,
    'last_second_name'  : last_second_name.value,
    'step'              : step.value,
    'company_id'        : user.value.company_id, // Asegúrate de incluir esto
    'plan_id'           : user.value.plan_id,
    'position_id'       : user.value.position_id,
    'account_id'        : user.value.account_id,
    'rol'              : selectedRoles.value,
    'source'            : 'broker',
    'status': blockUser.value ? 'block' : 'active', // Change this line
    'blockUser': blockUser.value ? 1 : 0 // Agrega esta línea para enviar el estado de bloqueo
  }
  console.log('params:', params); 

  try {
    let options = {
          headers: {
              'Authorization': `Bearer ${session.value.token_api}`
          }
    }

    const response = await axios.put(
        `${process.env.VUE_APP_API_BASE_URL}/broker/profile/${userId.value}/update-general`,
        params,
        options        
    );
    if (response.status == 200) {
      showToast('Datos guardados correctamente')
      if (session.value) {
        session.value.status = blockUser.value ? 'block' : 'active';
      }
      console.log(userId.value)
      if(session.value.step < 3 ){
        session.value.step=1;
        router.push({ name: "" });
        getProfile();
      }
    }

  } catch (error) {
        console.error("Error fetching data:", error);
  }
}
// Función para actualizar la cuenta del usuario
async function updateAccount() {
  let formData = new FormData();

  // Agrega datos al FormData y registra cada uno en la consola para verificar
  console.log("User ID:", userId.value);
  formData.append('user_id', userId.value);

  console.log("Email:", email.value);
  formData.append('email', email.value);

  // Añade la nueva contraseña si está presente y verifica con console.log
  if (password.value && passwordConfirmation.value) {
    console.log("Password:", password.value);
    console.log("Password Confirmation:", passwordConfirmation.value);
    formData.append('password', password.value);
    formData.append('password_confirmation', passwordConfirmation.value);
  }

  // Agrega la imagen de fondo si se seleccionó una y verifica con console.log
  if (profileImageSrc.value) {
    if (profileImageSrc.value instanceof File) {
      console.log("Background Profile (File):", profileImageSrc.value);
      formData.append('background_profile', profileImageSrc.value);
    } else if (typeof profileImageSrc.value === 'string' && profileImageSrc.value.startsWith('data:image')) {
      console.log("Background Profile (Base64):", profileImageSrc.value);
      const backgroundFile = base64ToFile(profileImageSrc.value, 'background_profile.jpg');
      formData.append('background_profile', backgroundFile);
    }
  }
    // Procesar imagen de perfil (imageSrc)
    if (imageSrc.value) {
      if (imageSrc.value instanceof File) {
        console.log("Profile Avatar (File):", imageSrc.value);
        formData.append('profile_avatar', imageSrc.value);
      } else if (typeof imageSrc.value === 'string' && imageSrc.value.startsWith('data:image')) {
        console.log("Profile Avatar (Base64):", imageSrc.value);
        const profileAvatarFile = base64ToFile(imageSrc.value, 'profile_avatar.jpg');
        formData.append('profile_avatar', profileAvatarFile);
      }
    }

  // Imprime todos los pares clave-valor de FormData para verificación
  for (let pair of formData.entries()) {
    console.log(`${pair[0]}: ${pair[1]}`);
  }

  try {
    let options = {
      headers: {
        'Authorization': `Bearer ${session.value.token_api}`
      }
    };

    const response = await axios.post(
      `${process.env.VUE_APP_API_BASE_URL}/broker/profile/update-account`,
      formData,
      options
    );
    console.log(formData)
    // Verifica la respuesta
    if (response.data.status === 'success') {
      showToast('Datos actualizados correctamente');
    } else {
      showToast('error', response.data.error || 'Error al actualizar los datos');
    }
  } catch (error) {
    console.error("Error al actualizar la cuenta:", error);
    showToast('error', 'Hubo un problema al actualizar la cuenta');
  }
}
const base64ToFile=(base64Data, filename)=> {
  let arr = base64Data.split(',');
  let mime = arr[0].match(/:(.*?);/)[1];
  let bstr = atob(arr[1]);
  let n = bstr.length;
  let u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
}
const showToast = (message) => {
  successMessage.value = message;
  setTimeout(() => {
    successMessage.value = ''; // Ocultar el mensaje después de 3 segundos
  }, 3000);
}

// Computed properties
//const isRoleAdminOrManager = computed(() => {
//  return session.value && (session.value.role === 'admin' || session.value.role === 'manager');
//});


</script>


<style scoped>
  /* Label personalizado */
  ::v-deep .custom-label label,
  ::v-deep .custom-label label.block.mb-2.text-sm.font-medium {
    @apply text-white;
  }

  /* Fondo del body */
  body {
    background-color: #ffffff !important;
  }

  /* Imagen de usuario */
  .user-image {
    position: relative;
    margin-top: -60px;
    margin-bottom: 1rem;
  }
  .avatar {
    @apply rounded-full w-32 h-32 border-4 border-white inline-block overflow-hidden;
  }

  /* Media queries para ajustes específicos */
  @media (max-width: 640px) {
    .user-image {
      @apply -mt-6;
    }
    
    .card-header {
      @apply py-1;
    }
    
    .text-xl {
      @apply text-lg;
    }
  }

  input,
  select,
  textarea {
    @apply w-full px-3 py-2 text-sm;
    -webkit-appearance: none;
    appearance: none;
  }

  /* Mejorar la interactividad en dispositivos táctiles */
  button,
  [type='button'],
  [type='submit'] {
    @apply cursor-pointer;
    touch-action: manipulation;
  }

  /* Asegurar que los checkboxes y radio buttons sean fáciles de tocar en móvil */
  input[type='checkbox'],
  input[type='radio'] {
    @apply w-5 h-5;
  }

  /* Roles en contenedor flexible */
  .roles-container {
    @apply flex flex-wrap gap-4;
  }

  /* Checkbox seleccionado */
  .form-check-input:checked {
    @apply bg-pink-500 border-pink-500;
  }
</style>
